import React, { useState, useEffect } from 'react';
import { Typography, Modal, Box, IconButton, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ResponsiveImage = ({ src, alt, caption }) => {
  const [maxWidth, setMaxWidth] = useState('100%');
  const [maxHeight, setMaxHeight] = useState('90%');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMaxWidth('60%');
      } else if (window.innerWidth >= 768) {
        setMaxWidth('75%');
      } else {
        setMaxWidth('100%');
      }
      setMaxHeight(window.innerHeight - 50);
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('keydown', handleKeyDown);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth,
          maxHeight,
          height: 'auto',
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: 8,
          cursor: 'pointer',
        }}
        onClick={() => setOpen(true)}
      />
      {caption && (
        <Typography
          variant="caption"
          sx={{ display: 'block', textAlign: 'center', mt: 0.5, fontSize: '0.65rem' }}
        >
          {caption}
        </Typography>
      )}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              outline: 'none',
              bgcolor: 'rgba(0,0,0,0.9)',
              p: 1,
              borderRadius: 1,
            }}
            onClick={() => setOpen(false)}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                color: '#fff',
                zIndex: 10,
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* Image */}
            <img
              src={src}
              alt={alt}
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default ResponsiveImage;